// extracted by mini-css-extract-plugin
export default {"carouselGalleryContainer":"CarouselGallery_carouselGalleryContainer__HDvfi","item":"CarouselGallery_item__bXWl2"};